import React, { Component } from "react";
import propTypes from "prop-types";
import Loading from "react-loading-animation";
import Select, { Creatable } from "react-select";
import "react-select/dist/react-select.css";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
  ButtonGroup,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import InputDatetime from "../../components/Form/InputDatetime/InputDatetime";
import {
  errorMessage,
  hasError,
  textValue,
  textChange,
  dateChange,
  dateValue,
  checkChange
} from "../../utils/form";
import { normalizeSku } from "../../helpers/sku";
import classNames from "classnames";
import { ButtonLoading } from "../../components/Button";
import SelectProduct from "../../components/Form/Select/Async/SelectProduct";
import { Redirect } from "react-router-dom";
import RichTextEditor, {getTextAlignBlockMetadata, getTextAlignClassName, getTextAlignStyles} from "react-rte";
import moment from 'moment-timezone';
import BadgeThin from "../../components/Badges/BadgeThin";
import { apiClient } from "../../utils/Api";
import { normalizeValidationErrors } from "../../utils/errMsg";

// import {convertToRaw} from 'draft-js';

const MARKETPLACE_PRODUCT_ID_FIELDS = [
  { name: "tiktok_product_id", label: "Tiktok Product ID" },
  { name: "tiktok_product_id_po", label: "PO Tiktok Product ID" },
  { name: "shopee_product_id", label: "Shopee Product ID" },
  { name: "shopee_product_id_po", label: "PO Shopee Product ID" }
];

const emptyMarketplaceProductIds = () => ({
  tiktok_product_id: "",
  tiktok_product_id_po: "",
  shopee_product_id: "",
  shopee_product_id_po: ""
});

const normalizeMarketplaceProductId = value => String(value || "").trim();

const marketplaceProductIdsFromVariant = variant => ({
  tiktok_product_id: normalizeMarketplaceProductId(variant.tiktok_product_id),
  tiktok_product_id_po: normalizeMarketplaceProductId(variant.tiktok_product_id_po),
  shopee_product_id: normalizeMarketplaceProductId(variant.shopee_product_id),
  shopee_product_id_po: normalizeMarketplaceProductId(variant.shopee_product_id_po)
});

export default class ProductVariant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _form: {
        product: null,
        weight: 3492,
        sex: "M",
        currency: "USD",
        detailsValue: RichTextEditor.createEmptyValue(),
        details: "",
        auto_sync: false,
        vintage: false,
        receive_sell: true,
        biddable: true,
        anchanto_whitelisted: false,
        tiktok_whitelisted: false,
        shopee_whitelisted: false,
        tiktok_markup: "",
        tiktok_buffer: "",
        tiktok_markup_is_override: false,
        shopee_markup: "",
        shopee_buffer: "",
        shopee_markup_is_override: false,
        ...emptyMarketplaceProductIds()
      },
      _errorForm: [],
      _errorMsg: null,
      _statusCode: 0,
      _defaultRibbonTags:[
        {
          label: "collection",
          value: "collection"
        },
        {
          label: "best-selling",
          value: "best-selling"
        },
        {
          label: "search",
          value: "search"
        },
      ],
      _defaultTags: [
        {
          label: "nike",
          value: "nike"
        },
        {
          label: "adidas",
          value: "adidas"
        },
        {
          label: "vapormax",
          value: "vapormax"
        },
        {
          label: "airjordan",
          value: "airjordan"
        },
        {
          label: "ultraboost",
          value: "ultraboost"
        },
        {
          label: "yeezy",
          value: "yeezy"
        }
      ],
      _isSubmitProgress: false,
      _isDeleteProgress: false,
      _isForceTiktokSyncModalOpen: false,
      _forceTiktokSyncPo: false,
      _isForceTiktokSyncProgress: false,
      _forceTiktokSyncAlert: null,
      _savedTiktokWhitelisted: false,
      _isForceShopeeSyncModalOpen: false,
      _forceShopeeSyncPo: false,
      _isForceShopeeSyncProgress: false,
      _forceShopeeSyncAlert: null,
      _savedShopeeWhitelisted: false,
      _anchantoMarkupsDirty: false,
      _marketplaceProductIdsDirty: false,
      _savedMarketplaceProductIds: emptyMarketplaceProductIds(),
      _isMarketplaceProductIdConfirmOpen: false,
      _marketplaceProductIdChanges: []
    };
    this.handleChangeEditor = this.handleChangeEditor.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckedChange = this.handleCheckedChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this._closeMarketplaceProductIdConfirmModal = this._closeMarketplaceProductIdConfirmModal.bind(this);
    this._confirmMarketplaceProductIdChanges = this._confirmMarketplaceProductIdChanges.bind(this);
    this._openForceTiktokSyncModal = this._openForceTiktokSyncModal.bind(this);
    this._closeForceTiktokSyncModal = this._closeForceTiktokSyncModal.bind(this);
    this._handleForceTiktokSync = this._handleForceTiktokSync.bind(this);
    this._openForceShopeeSyncModal = this._openForceShopeeSyncModal.bind(this);
    this._closeForceShopeeSyncModal = this._closeForceShopeeSyncModal.bind(this);
    this._handleForceShopeeSync = this._handleForceShopeeSync.bind(this);
    this._handleOnSelectedProductChange = this._handleOnSelectedProductChange.bind(
      this
    );
    this._handleOnSelectProductOpen = this._handleOnSelectProductOpen.bind(
      this
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isLoading === false &&
      nextProps.isLoading !== this.props.isLoading
    ) {
      // After load product details
      if (nextProps.productVariant.status_code === 200) {
        let { nickname, ribbon_tag } = nextProps.productVariant;
        const tags =
          nickname !== null
            ? nickname.split(",").map(tag => ({ label: tag, value: tag }))
            : [];
        const ribbons =
          ribbon_tag && ribbon_tag !== null
              ? ribbon_tag.split(",").map(tag => ({ label: tag, value: tag }))
              : [];
        const { retail_price, retail_price_indonesia } = nextProps.productVariant;
        const anchantoMarkups = nextProps.productVariant.anchanto_markups || {};
        const tiktokMarkup = anchantoMarkups.tiktok || {};
        const shopeeMarkup = anchantoMarkups.shopee || {};

        this.setState({
          _form: {
            ...nextProps.productVariant,
            retail_price: parseInt(retail_price || 0),
            retail_price_indonesia: parseInt(retail_price_indonesia || 0),
            subcategory_id: nextProps.productVariant.subcategory_id || '',
            product: nextProps.productVariant.product_id && {
              id: nextProps.productVariant.product_id,
              name: nextProps.productVariant.product.name,
              category: nextProps.productVariant.product.category,
              brand: nextProps.productVariant.product.brand
            },
            detailsValue: nextProps.productVariant.details
              ? RichTextEditor.createValueFromString(
                  nextProps.productVariant.details,
                  "html",
									{
										customBlockFn: getTextAlignBlockMetadata,
									}
                )
              : RichTextEditor.createEmptyValue(),
            tags,
            ribbons,
            tiktok_markup:
              tiktokMarkup.percent === undefined || tiktokMarkup.percent === null
                ? ""
                : tiktokMarkup.percent,
            tiktok_buffer:
              tiktokMarkup.buffer === undefined || tiktokMarkup.buffer === null
                ? ""
                : tiktokMarkup.buffer,
            tiktok_markup_is_override: !!tiktokMarkup.is_override,
            shopee_markup:
              shopeeMarkup.percent === undefined || shopeeMarkup.percent === null
                ? ""
                : shopeeMarkup.percent,
            shopee_buffer:
              shopeeMarkup.buffer === undefined || shopeeMarkup.buffer === null
                ? ""
                : shopeeMarkup.buffer,
            shopee_markup_is_override: !!shopeeMarkup.is_override,
            ...marketplaceProductIdsFromVariant(nextProps.productVariant)
          },
          _savedTiktokWhitelisted: !!nextProps.productVariant.tiktok_whitelisted,
          _savedShopeeWhitelisted: !!nextProps.productVariant.shopee_whitelisted,
          _anchantoMarkupsDirty: false,
          _marketplaceProductIdsDirty: false,
          _savedMarketplaceProductIds: marketplaceProductIdsFromVariant(
            nextProps.productVariant
          )
        });
      }
    }
    if (
      this.state._isSubmitProgress &&
      nextProps.isSubmitProgress === false &&
      nextProps.isSubmitProgress !== this.props.isSubmitProgress
    ) {
      // After submit to api
      if (
        nextProps.productVariant.status_code === 200 &&
        nextProps.error === null
      ) {
        this.setState({ _isSubmitProgress: false }, () => {
          if (
            this.state._form.id === undefined ||
            this.state._form.id === null
          ) {
            this.setState({
              _redirectToDetail: true,
              _form: { ...this.state._form, id: nextProps.productVariant.id },
              _savedTiktokWhitelisted: !!this.state._form.tiktok_whitelisted,
              _savedShopeeWhitelisted: !!this.state._form.shopee_whitelisted,
              _savedMarketplaceProductIds: marketplaceProductIdsFromVariant(
                nextProps.productVariant
              )
            });
          } else {
            let { _form } = this.state;
            _form.updated_at = nextProps.productVariant.updated_at;
            const anchantoMarkups = nextProps.productVariant.anchanto_markups;
            if (anchantoMarkups) {
              const tiktokMarkup = anchantoMarkups.tiktok || {};
              const shopeeMarkup = anchantoMarkups.shopee || {};
              _form = {
                ..._form,
                tiktok_markup:
                  tiktokMarkup.percent === undefined || tiktokMarkup.percent === null
                    ? _form.tiktok_markup
                    : tiktokMarkup.percent,
                tiktok_buffer:
                  tiktokMarkup.buffer === undefined || tiktokMarkup.buffer === null
                    ? _form.tiktok_buffer
                    : tiktokMarkup.buffer,
                tiktok_markup_is_override: !!tiktokMarkup.is_override,
                shopee_markup:
                  shopeeMarkup.percent === undefined || shopeeMarkup.percent === null
                    ? _form.shopee_markup
                    : shopeeMarkup.percent,
                shopee_buffer:
                  shopeeMarkup.buffer === undefined || shopeeMarkup.buffer === null
                    ? _form.shopee_buffer
                    : shopeeMarkup.buffer,
                shopee_markup_is_override: !!shopeeMarkup.is_override
              };
            }
            const savedMarketplaceProductIds = marketplaceProductIdsFromVariant(
              nextProps.productVariant
            );
            this.setState({
              _form: {
                ..._form,
                ...savedMarketplaceProductIds
              },
              _savedTiktokWhitelisted: !!_form.tiktok_whitelisted,
              _savedShopeeWhitelisted: !!_form.shopee_whitelisted,
              _anchantoMarkupsDirty: false,
              _marketplaceProductIdsDirty: false,
              _savedMarketplaceProductIds: savedMarketplaceProductIds
            });
          }
        });
      } else {
        this.setState({
          _isSubmitProgress: false,
          _errorForm: normalizeValidationErrors(nextProps.error)
        });
      }
    }
    if(nextProps.error !==this.props.error 
      && nextProps.error){
      this.setState({
        _isSubmitProgress: false,
        _errorForm: normalizeValidationErrors(nextProps.error)
      });
    }
  }

  handleChangeEditor(value) {
		const formatHtml = value.toString('html', {blockStyleFn: getTextAlignStyles});
		this.setState(prevState => ({
			_form: {
				...prevState._form,
				detailsValue: value,
				details: formatHtml,
			}
		}));
  }

  handleOnChange(value, name) {
    const { _form } = this.state;
    _form[name] = value;
    this.setState({ _form });
  }
  handleChange(e) {
    const name = e.target.name;
    let _form = textChange(e, this.state._form);
    const markupFieldChanged =
      name === "tiktok_markup" ||
      name === "tiktok_buffer" ||
      name === "shopee_markup" ||
      name === "shopee_buffer";
    const marketplaceProductIdChanged =
      name === "tiktok_product_id" ||
      name === "tiktok_product_id_po" ||
      name === "shopee_product_id" ||
      name === "shopee_product_id_po";
    if (name === "tiktok_markup" || name === "tiktok_buffer") {
      _form = { ..._form, tiktok_markup_is_override: true };
    }
    if (name === "shopee_markup" || name === "shopee_buffer") {
      _form = { ..._form, shopee_markup_is_override: true };
    }
    const nextState = { _form };
    if (markupFieldChanged) {
      nextState._anchantoMarkupsDirty = true;
    }
    if (marketplaceProductIdChanged) {
      nextState._marketplaceProductIdsDirty = true;
    }
    this.setState(nextState);
  }

  _buildAnchantoStoreMarkup(percent, buffer, isOverride) {
    const parsedPercent = parseFloat(percent);
    const parsedBuffer = parseInt(buffer, 10);
    return {
      percent: Number.isNaN(parsedPercent) ? 0 : parsedPercent,
      buffer: Number.isNaN(parsedBuffer) ? 0 : parsedBuffer,
      is_override: !!isOverride
    };
  }

  handleCheckedChange(e) {
    const { product } = this.state._form;
    if(e.target.name==='editors_choice'){
      if(e.target.checked)
        this.props.setEditorsChoice(product.category.name.toLowerCase(), 'INC');
      else
        this.props.setEditorsChoice(product.category.name.toLowerCase(), 'DEC');
    }
    const _form = checkChange(e, this.state._form);
    this.setState({ _form: { ..._form } });
  }

  handleDatePickerChange(value, name) {
    const date = name === 'ended_at' && value ? moment(value).endOf('day') : value;
    const _form = dateChange(date, name, this.state._form);
    this.setState({ _form });
  }

  handleSelectedChange(option, name) {
    const { _form } = this.state;
    _form[name] = option === null ? option : option.value;
    this.setState({ _form });
  }

  handleSKUBlur = () => {
    this.setState({
      _form: { ...this.state._form, SKU: normalizeSku(this.state._form.SKU) }
    });
  };

  _validateForm = (form = this.state._form) => {
    const { product,display_name,colour,SKU }= form;
    let errors={};
    if(!product)
      errors['product_id']=['The product id field is required.'];
    if(!display_name)
      errors['display_name']=['The display name field is required.'];
    if(!colour)
      errors['colour']=['The colour field is required.'];
    if(!SKU)
      errors['SKU']=['The SKU field is required.'];
    if(Object.keys(errors).length){
      this.setState({
        _errorForm:{errors:{...errors}},
        _errorMsg:'Please fulfill your form.',
        _statusCode: 422
      })
      return true;
    }
    return false;
  }

  _getMarketplaceProductIdChanges() {
    const saved = this.state._savedMarketplaceProductIds || emptyMarketplaceProductIds();
    return MARKETPLACE_PRODUCT_ID_FIELDS.reduce((changes, field) => {
      const from = normalizeMarketplaceProductId(saved[field.name]);
      const to = normalizeMarketplaceProductId(this.state._form[field.name]);
      if (from !== to) {
        changes.push({ ...field, from, to });
      }
      return changes;
    }, []);
  }

  _closeMarketplaceProductIdConfirmModal() {
    if (this.state._isSubmitProgress) return;
    this.setState({
      _isMarketplaceProductIdConfirmOpen: false,
      _marketplaceProductIdChanges: []
    });
  }

  _confirmMarketplaceProductIdChanges() {
    this.setState({ _isMarketplaceProductIdConfirmOpen: false }, () => {
      this._submitForm();
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const normalizedSKU = normalizeSku(this.state._form.SKU);
    this.setState({
      _form: { ...this.state._form, SKU: normalizedSKU }
    });
    const hasError = this._validateForm({ ...this.state._form, SKU: normalizedSKU });
    if(hasError || this.props.isMaxEditorsChoice){
      return;
    }
    const marketplaceProductIdChanges = this._getMarketplaceProductIdChanges();
    if (marketplaceProductIdChanges.length > 0) {
      this.setState({
        _isMarketplaceProductIdConfirmOpen: true,
        _marketplaceProductIdChanges: marketplaceProductIdChanges
      });
      return;
    }
    this._submitForm();
  }

  _submitForm() {
    const normalizedSKU = normalizeSku(this.state._form.SKU);
    const _form = { ...this.state._form, SKU: normalizedSKU };
    const { product } = this.state._form
    _form.product_id = _form.product !== null ? _form.product.id : undefined;
    // _form.product = undefined;
    _form.nickname =
      _form.tags && typeof _form.tags === typeof [] && _form.tags.length
        ? _form.tags
            .map(tag => tag.value)
            .reduce((concat, tag) => concat + "," + tag)
        : null;
    _form.ribbon_tag =
      _form.ribbons && typeof _form.ribbons === typeof [] && _form.ribbons.length
        ? _form.ribbons
            .map(ribbon => ribbon.value)
            .reduce((concat, ribbon) => concat + "," + ribbon)
        : null;
    _form.active =
      _form.active === undefined || _form.active === null
        ? false
        : _form.active;
    _form.editors_choice =
      _form.editors_choice === undefined || _form.editors_choice === null
        ? false
        : _form.editors_choice;
    _form.hide_box_info =
      _form.hide_box_info === undefined || _form.hide_box_info === null
        ? false
        : _form.hide_box_info;
    _form.vintage =
      _form.vintage === undefined || _form.vintage === null
        ? false
        : _form.vintage;
    _form.receive_sell =
      _form.receive_sell === undefined || _form.receive_sell === null
        ? false
        : _form.receive_sell;
    _form.biddable =
      _form.biddable === undefined || _form.biddable === null
        ? false
        : _form.biddable;
    _form.subcategory_id =
      _form.subcategory_id === '' || _form.subcategory_id == null
        ? null
        : parseInt(_form.subcategory_id, 10);
    //force to vintage=false if product not apparels category
    if(product && product.category && product.category.name.toLowerCase() !== "apparels"){
      _form.vintage = false;
    }
    _form.voucher_applicable =
    _form.voucher_applicable === undefined || _form.voucher_applicable === null
      ? false
      : _form.voucher_applicable;
    _form.anchanto_whitelisted =
    _form.anchanto_whitelisted === undefined || _form.anchanto_whitelisted === null
      ? false
      : _form.anchanto_whitelisted;
    _form.tiktok_whitelisted =
    _form.tiktok_whitelisted === undefined || _form.tiktok_whitelisted === null
      ? false
      : _form.tiktok_whitelisted;
    _form.shopee_whitelisted =
    _form.shopee_whitelisted === undefined || _form.shopee_whitelisted === null
      ? false
      : _form.shopee_whitelisted;
    if (this.state._anchantoMarkupsDirty) {
      _form.anchanto_markups = {
        tiktok: this._buildAnchantoStoreMarkup(
          _form.tiktok_markup,
          _form.tiktok_buffer,
          _form.tiktok_markup_is_override
        ),
        shopee: this._buildAnchantoStoreMarkup(
          _form.shopee_markup,
          _form.shopee_buffer,
          _form.shopee_markup_is_override
        )
      };
    }
    if (
      this.state._marketplaceProductIdsDirty ||
      this._getMarketplaceProductIdChanges().length > 0
    ) {
      _form.tiktok_product_id = normalizeMarketplaceProductId(_form.tiktok_product_id);
      _form.tiktok_product_id_po = normalizeMarketplaceProductId(_form.tiktok_product_id_po);
      _form.shopee_product_id = normalizeMarketplaceProductId(_form.shopee_product_id);
      _form.shopee_product_id_po = normalizeMarketplaceProductId(_form.shopee_product_id_po);
    } else {
      delete _form.tiktok_product_id;
      delete _form.tiktok_product_id_po;
      delete _form.shopee_product_id;
      delete _form.shopee_product_id_po;
    }
    this.setState({ _isSubmitProgress: true, _errorForm: [] }, () => {
      this.props.onSubmit({ ..._form });
    });
  }

  onDelete() {
    this.setState({ _isDeleteProgress: true }, () => this.props.onDelete());
  }

  _openForceTiktokSyncModal() {
    this.setState({
      _isForceTiktokSyncModalOpen: true,
      _forceTiktokSyncPo: false,
      _forceTiktokSyncAlert: null
    });
  }

  _closeForceTiktokSyncModal() {
    if (this.state._isForceTiktokSyncProgress) return;
    this.setState({ _isForceTiktokSyncModalOpen: false });
  }

  async _handleForceTiktokSync() {
    const productVariantId = this.state._form.id;
    if (!productVariantId) return;

    this.setState({ _isForceTiktokSyncProgress: true, _forceTiktokSyncAlert: null });
    try {
      const isPo = !!this.state._forceTiktokSyncPo;
      const tiktokProductId = String(
        (isPo
          ? this.state._form.tiktok_product_id_po
          : this.state._form.tiktok_product_id) || ""
      ).trim();
      const payload = {
        product_variant_id: Number(productVariantId),
        po: isPo,
        force: true
      };
      if (tiktokProductId) {
        payload.product_id = tiktokProductId;
      }
      const response = await apiClient().post("/admins/tiktok/sync-variants", payload);
      const output =
        (response.data &&
          response.data.data &&
          response.data.data.output) ||
        (response.data && response.data.message) ||
        "TikTok variant sync completed.";
      this.setState({
        _isForceTiktokSyncProgress: false,
        _isForceTiktokSyncModalOpen: false,
        _forceTiktokSyncAlert: { color: "success", message: output }
      });
    } catch (error) {
      const data = (error.response && error.response.data) || {};
      const message =
        data.output ||
        (data.error && data.error.message) ||
        data.message ||
        "TikTok variant sync failed.";
      this.setState({
        _isForceTiktokSyncProgress: false,
        _isForceTiktokSyncModalOpen: false,
        _forceTiktokSyncAlert: { color: "danger", message }
      });
    }
  }

  _openForceShopeeSyncModal() {
    this.setState({
      _isForceShopeeSyncModalOpen: true,
      _forceShopeeSyncPo: false,
      _forceShopeeSyncAlert: null
    });
  }

  _closeForceShopeeSyncModal() {
    if (this.state._isForceShopeeSyncProgress) return;
    this.setState({ _isForceShopeeSyncModalOpen: false });
  }

  async _handleForceShopeeSync() {
    const productVariantId = this.state._form.id;
    if (!productVariantId) return;

    this.setState({ _isForceShopeeSyncProgress: true, _forceShopeeSyncAlert: null });
    try {
      const isPo = !!this.state._forceShopeeSyncPo;
      const shopeeProductId = String(
        (isPo
          ? this.state._form.shopee_product_id_po
          : this.state._form.shopee_product_id) || ""
      ).trim();
      const payload = {
        product_variant_id: Number(productVariantId),
        po: isPo,
        force: true
      };
      if (shopeeProductId) {
        payload.product_id = shopeeProductId;
      }
      const response = await apiClient().post("/admins/shopee/sync-variants", payload);
      const output =
        (response.data &&
          response.data.data &&
          response.data.data.output) ||
        (response.data && response.data.message) ||
        "Shopee variant sync completed.";
      this.setState({
        _isForceShopeeSyncProgress: false,
        _isForceShopeeSyncModalOpen: false,
        _forceShopeeSyncAlert: { color: "success", message: output }
      });
    } catch (error) {
      const data = (error.response && error.response.data) || {};
      const message =
        data.output ||
        (data.error && data.error.message) ||
        data.message ||
        "Shopee variant sync failed.";
      this.setState({
        _isForceShopeeSyncProgress: false,
        _isForceShopeeSyncModalOpen: false,
        _forceShopeeSyncAlert: { color: "danger", message }
      });
    }
  }

  _handleOnSelectedProductChange(option) {
    const { _form } = this.state;
    _form.product = option;
    _form.subcategory_id = '';
    this.setState({ _form }, () => {
      const categoryId = option && option.category ? option.category.id : null;
      this.props.onFetchSubcategoryOptions(categoryId);
    });
  }

  _handleOnSelectProductOpen() {
    if (this.state._form.product) {
      if (this.state._recentSearchProduct) {
        this.refs.selectProduct.loadSelectOptions(
          this.state._recentSearchProduct
        );
      } else {
        this.refs.selectProduct.loadSelectOptions(
          this.state._form.product.name
        );
      }
    } else {
      this.refs.selectProduct.loadSelectOptions("");
    }
  }

  render() {
    if (this.state._redirectToDetail) {
      return <Redirect to={`/product_variants/${this.state._form.id}`} />;
    }
    const { product } = this.props.productVariant
    const { product: productForm } = this.state._form
    const category = product && product.category_id? product.category.name.toLowerCase(): null;
    const categoryEdit = productForm && productForm.category? productForm.category.name.toLowerCase(): null;
    const brandName = productForm && productForm.brand? productForm.brand.name: null;
    const isForceTiktokSyncDisabled =
      this.state._isForceTiktokSyncProgress ||
      !this.state._savedTiktokWhitelisted ||
      !textValue("tiktok_whitelisted", this.state._form);
    const isForceShopeeSyncDisabled =
      this.state._isForceShopeeSyncProgress ||
      !this.state._savedShopeeWhitelisted ||
      !textValue("shopee_whitelisted", this.state._form);
    
    return (
      <Loading isLoading={this.props.isLoading}>
        <Col>
          <Alert color="danger" isOpen={this.state._statusCode === 422} toggle={() => this.setState({_statusCode: 0})}>
            <strong>Opps...</strong> {this.state._errorMsg}
          </Alert>
          <Form onSubmit={this.onSubmit}>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "product_id",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductId">
                Product{' '}{
                categoryEdit ? 
                  <span>
                    <BadgeThin>{categoryEdit}</BadgeThin> 
                    <BadgeThin style={{backgroundColor: '#4fa1b7', marginLeft: 4}}>{brandName}</BadgeThin>
                  </span> : null
                }
              </Label>
              <SelectProduct
                id="formProductId"
                name="product"
                ref="selectProduct"
                placeholder="Select a product..."
                noResultsText="Cannot find product."
                cacheOptions={false}
                value={this.state._form.product}
                onSelectSearch={input =>
                  this.setState({ _recentSearchProduct: input })
                }
                onSelectChange={this._handleOnSelectedProductChange}
                onSelectOpen={this._handleOnSelectProductOpen}
              />
              {errorMessage("product_id", this.state._errorForm)}
            </FormGroup>
            {
              productForm && productForm.category ? (
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "subcategory_id",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formSubcategoryId">Subcategory</Label>
                  <Input
                    type="select"
                    id="formSubcategoryId"
                    name="subcategory_id"
                    value={textValue("subcategory_id", this.state._form) || ''}
                    onChange={this.handleChange}
                    disabled={this.props.subcategoryOptionsLoading}
                  >
                    <option value="">None</option>
                    {
                      this.props.subcategoryOptions.map(item => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))
                    }
                  </Input>
                  {errorMessage("subcategory_id", this.state._errorForm)}
                </FormGroup>
              ) : (
                <FormGroup>
                  <Label for="formSubcategoryId">Subcategory</Label>
                  <Input type="select" id="formSubcategoryId" disabled value="">
                    <option value="">Select a product first</option>
                  </Input>
                </FormGroup>
              )
            }
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "display_name",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductDisplayName">Display Name</Label>
              <Input
                type="text"
                id="formProductDisplayName*"
                name="display_name"
                placeholder="Enter a Display Name"
                value={textValue("display_name", this.state._form)}
                onChange={this.handleChange}
              />
              {errorMessage("display_name", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "type",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductType">Type / Material</Label>
              <Input
                type="text"
                id="formProductType"
                name="type"
                placeholder="Enter a Type"
                value={textValue("type", this.state._form)}
                onChange={this.handleChange}
              />
              {errorMessage("type", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "dimension",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductDimension">Dimension</Label>
              <Input
                type="text"
                id="formProductDimension"
                name="dimension"
                placeholder="Enter product dimension"
                value={textValue("dimension", this.state._form)}
                onChange={this.handleChange}
              />
              {errorMessage("dimension", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "nickname",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductNickName">Nickname Or Tags</Label>
              <Creatable
                multi
                options={this.state._defaultTags}
                value={this.state._form.tags}
                onChange={val => this.handleOnChange(val, 'tags')}
                placeholder="Enter a nickname or tags"
              />
              {errorMessage("nickname", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "ribbon_tag",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductRibbonTag">Ribbon Tags</Label>
              <Creatable
                multi
                options={this.state._defaultRibbonTags}
                value={this.state._form.ribbons}
                onChange={ val => this.handleOnChange (val, 'ribbons')}
                placeholder="Enter a ribbon tags"
              />
              {errorMessage("ribbon_tag", this.state._errorForm)}
            </FormGroup>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "colour",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductColour">Colour</Label>
                  <Input
                    type="text"
                    id="formProductColour"
                    name="colour"
                    placeholder="Enter a Colour*"
                    value={textValue("colour", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("colour", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "weight",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductWeight">Weight</Label>
                  <Input
                    type="text"
                    id="formProductWeight"
                    name="weight"
                    placeholder="Enter a Weight*"
                    value={textValue("weight", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("weight", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "SKU",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductSKU">SKU</Label>
              <Input
                type="text"
                id="formProductSKU"
                name="SKU"
                placeholder="Enter a SKU*"
                value={textValue("SKU", this.state._form)}
                onChange={this.handleChange}
                onBlur={this.handleSKUBlur}
              />
              {errorMessage("SKU", this.state._errorForm)}
            </FormGroup>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "sex",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductSex">Sex</Label>
                  <Select
                    id="formProductSex"
                    name="sex"
                    value={textValue("sex", this.state._form)}
                    options={[
                      { value: "U", label: "Unisex" },
                      { value: "F", label: "Female" },
                      { value: "M", label: "Male" },
                      { value: "P", label: "Primary School" },
                      { value: "GS", label: "Grade School" },
                      { value: "IT", label: "Infant Toddler" }
                    ]}
                    onChange={val => {
                      this.handleSelectedChange(val, "sex");
                    }}
                  />
                  {errorMessage("sex", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "active",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductActive">Set to Active &nbsp;</Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="active"
                  id="formProductActive"
                  value="true"
                  checked={textValue("active", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("active", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "auto_sync",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductAutoScrape">
                Set to Auto Scrape &nbsp;
              </Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="auto_sync"
                  id="formProductAutoScrape"
                  value="true"
                  checked={textValue("auto_sync", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("auto_sync", this.state._errorForm)}
            </FormGroup>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "editors_choice",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductEditorChoice">
                    Set to Hot Product &nbsp;
                  </Label>
                  <label className="switch switch-text switch-success-outline-alt">
                    <input
                      type="checkbox"
                      className="switch-input"
                      name="editors_choice"
                      id="formProductEditorChoice"
                      value="true"
                      checked={textValue("editors_choice", this.state._form)}
                      onChange={this.handleCheckedChange}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                  {errorMessage("editors_choice", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "editors_position",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductEditorsPosition">Position</Label>
                  <Input
                    type="number"
                    id="formProductEditorsPosition"
                    name="editors_position"
                    placeholder="Enter a hot product's position"
                    value={textValue("editors_position", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("editors_position", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "vintage",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductVintage">
                Set to Vintage &nbsp;
              </Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="vintage"
                  id="formProductVintage"
                  disabled={category !== "apparels"}
                  value="true"
                  checked={textValue("vintage", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("vintage", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "biddable",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductMakeOffer">
                Can Make Offer &nbsp;
              </Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="biddable"
                  id="formProductMakeOffer"
                  value="true"
                  checked={textValue("biddable", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("biddable", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "hide_box_info",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formProductHideBoxInfo">Hide Box Info &nbsp;</Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="hide_box_info"
                  id="formProductHideBoxInfo"
                  value="true"
                  checked={textValue("hide_box_info", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("hide_box_info", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "receive_sell",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formReceiveSell">Receive Sell Request &nbsp;</Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="receive_sell"
                  id="formReceiveSell"
                  value="true"
                  checked={textValue("receive_sell", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("receive_sell", this.state._errorForm)}
            </FormGroup>
            <FormGroup
              className={classNames({
                "has-danger has-feedback": hasError(
                  "voucher_applicable",
                  this.state._errorForm
                )
              })}
            >
              <Label for="formVoucherApplicable">Voucher Applicable &nbsp;</Label>
              <label className="switch switch-text switch-success-outline-alt">
                <input
                  type="checkbox"
                  className="switch-input"
                  name="voucher_applicable"
                  id="formVoucherApplicable"
                  value="true"
                  checked={textValue("voucher_applicable", this.state._form)}
                  onChange={this.handleCheckedChange}
                />
                <span
                  className="switch-label"
                  data-on="Yes"
                  data-off="No"
                ></span>
                <span className="switch-handle"></span>
              </label>
              {errorMessage("voucher_applicable", this.state._errorForm)}
            </FormGroup>
            <Row>
              <Col xs={12}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "anchanto_whitelisted",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductAnchantoWhitelisted">Sync to Anchanto &nbsp;</Label>
                  <label className="switch switch-text switch-success-outline-alt">
                    <input
                      type="checkbox"
                      className="switch-input"
                      name="anchanto_whitelisted"
                      id="formProductAnchantoWhitelisted"
                      value="true"
                      checked={textValue("anchanto_whitelisted", this.state._form)}
                      onChange={this.handleCheckedChange}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                  {errorMessage("anchanto_whitelisted", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "tiktok_whitelisted",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductTiktokWhitelisted">Sync To TikTok &nbsp;</Label>
                  <label className="switch switch-text switch-success-outline-alt">
                    <input
                      type="checkbox"
                      className="switch-input"
                      name="tiktok_whitelisted"
                      id="formProductTiktokWhitelisted"
                      value="true"
                      checked={textValue("tiktok_whitelisted", this.state._form)}
                      onChange={this.handleCheckedChange}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                  {errorMessage("tiktok_whitelisted", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "tiktok_product_id",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formTiktokProductId">Tiktok Product ID</Label>
                  <Input
                    type="text"
                    id="formTiktokProductId"
                    name="tiktok_product_id"
                    placeholder="Leave blank if none"
                    value={textValue("tiktok_product_id", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("tiktok_product_id", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "tiktok_product_id_po",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formTiktokProductIdPo">PO Tiktok Product ID</Label>
                  <Input
                    type="text"
                    id="formTiktokProductIdPo"
                    name="tiktok_product_id_po"
                    placeholder="Leave blank if none"
                    value={textValue("tiktok_product_id_po", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("tiktok_product_id_po", this.state._errorForm)}
                </FormGroup>
                {this.state._form.id ? (
                  <FormGroup>
                    <Button
                      type="button"
                      color={isForceTiktokSyncDisabled ? "secondary" : "warning"}
                      size="sm"
                      onClick={this._openForceTiktokSyncModal}
                      disabled={isForceTiktokSyncDisabled}
                      style={
                        isForceTiktokSyncDisabled
                          ? {
                              backgroundColor: "#c8ced3",
                              borderColor: "#c8ced3",
                              color: "#fff",
                              opacity: 1,
                              cursor: "default",
                              pointerEvents: "none"
                            }
                          : undefined
                      }
                    >
                      Force Tiktok Sync
                    </Button>
                  </FormGroup>
                ) : null}
                {this.state._forceTiktokSyncAlert ? (
                  <Alert
                    color={this.state._forceTiktokSyncAlert.color}
                    isOpen={!!this.state._forceTiktokSyncAlert}
                    style={{ position: "relative", paddingRight: "2.5rem" }}
                  >
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => this.setState({ _forceTiktokSyncAlert: null })}
                      style={{
                        position: "absolute",
                        top: "0.5rem",
                        right: "0.75rem",
                        zIndex: 2
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <pre style={{ whiteSpace: "pre-wrap", marginBottom: 0, fontFamily: "inherit" }}>
                      {this.state._forceTiktokSyncAlert.message}
                    </pre>
                  </Alert>
                ) : null}
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "anchanto_markups.tiktok.percent",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formTiktokMarkup">Tiktok Markup</Label>
                  <Input
                    type="number"
                    step="any"
                    min="0"
                    max="1"
                    id="formTiktokMarkup"
                    name="tiktok_markup"
                    placeholder="e.g. 0.25 for 25%"
                    value={textValue("tiktok_markup", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("anchanto_markups.tiktok.percent", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "anchanto_markups.tiktok.buffer",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formTiktokBuffer">Tiktok Buffer</Label>
                  <Input
                    type="number"
                    step="1"
                    min="0"
                    id="formTiktokBuffer"
                    name="tiktok_buffer"
                    placeholder="IDR flat buffer"
                    value={textValue("tiktok_buffer", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("anchanto_markups.tiktok.buffer", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "shopee_whitelisted",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductShopeeWhitelisted">Sync To Shopee &nbsp;</Label>
                  <label className="switch switch-text switch-success-outline-alt">
                    <input
                      type="checkbox"
                      className="switch-input"
                      name="shopee_whitelisted"
                      id="formProductShopeeWhitelisted"
                      value="true"
                      checked={textValue("shopee_whitelisted", this.state._form)}
                      onChange={this.handleCheckedChange}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                  {errorMessage("shopee_whitelisted", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "shopee_product_id",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formShopeeProductId">Shopee Product ID</Label>
                  <Input
                    type="text"
                    id="formShopeeProductId"
                    name="shopee_product_id"
                    placeholder="Leave blank if none"
                    value={textValue("shopee_product_id", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("shopee_product_id", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "shopee_product_id_po",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formShopeeProductIdPo">PO Shopee Product ID</Label>
                  <Input
                    type="text"
                    id="formShopeeProductIdPo"
                    name="shopee_product_id_po"
                    placeholder="Leave blank if none"
                    value={textValue("shopee_product_id_po", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("shopee_product_id_po", this.state._errorForm)}
                </FormGroup>
                {this.state._form.id ? (
                  <FormGroup>
                    <Button
                      type="button"
                      color={isForceShopeeSyncDisabled ? "secondary" : "warning"}
                      size="sm"
                      onClick={this._openForceShopeeSyncModal}
                      disabled={isForceShopeeSyncDisabled}
                      style={
                        isForceShopeeSyncDisabled
                          ? {
                              backgroundColor: "#c8ced3",
                              borderColor: "#c8ced3",
                              color: "#fff",
                              opacity: 1,
                              cursor: "default",
                              pointerEvents: "none"
                            }
                          : undefined
                      }
                    >
                      Force Shopee Sync
                    </Button>
                  </FormGroup>
                ) : null}
                {this.state._forceShopeeSyncAlert ? (
                  <Alert
                    color={this.state._forceShopeeSyncAlert.color}
                    isOpen={!!this.state._forceShopeeSyncAlert}
                    style={{ position: "relative", paddingRight: "2.5rem" }}
                  >
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => this.setState({ _forceShopeeSyncAlert: null })}
                      style={{
                        position: "absolute",
                        top: "0.5rem",
                        right: "0.75rem",
                        zIndex: 2
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <pre style={{ whiteSpace: "pre-wrap", marginBottom: 0, fontFamily: "inherit" }}>
                      {this.state._forceShopeeSyncAlert.message}
                    </pre>
                  </Alert>
                ) : null}
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "anchanto_markups.shopee.percent",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formShopeeMarkup">Shopee Markup</Label>
                  <Input
                    type="number"
                    step="any"
                    min="0"
                    max="1"
                    id="formShopeeMarkup"
                    name="shopee_markup"
                    placeholder="e.g. 0.25 for 25%"
                    value={textValue("shopee_markup", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("anchanto_markups.shopee.percent", this.state._errorForm)}
                </FormGroup>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "anchanto_markups.shopee.buffer",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formShopeeBuffer">Shopee Buffer</Label>
                  <Input
                    type="number"
                    step="1"
                    min="0"
                    id="formShopeeBuffer"
                    name="shopee_buffer"
                    placeholder="IDR flat buffer"
                    value={textValue("shopee_buffer", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("anchanto_markups.shopee.buffer", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <Modal
              isOpen={this.state._isForceTiktokSyncModalOpen}
              toggle={this._closeForceTiktokSyncModal}
              size="sm"
            >
              <ModalHeader toggle={this._closeForceTiktokSyncModal}>
                Force Tiktok Sync
              </ModalHeader>
              <ModalBody>
                <p className="mb-3">
                  Sync TikTok stock and price for this variant
                  {this.state._form.SKU ? ` (${this.state._form.SKU})` : ""}.
                </p>
                <FormGroup tag="fieldset">
                  <Label>Stock type</Label>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="forceTiktokSyncPo"
                        checked={!this.state._forceTiktokSyncPo}
                        onChange={() => this.setState({ _forceTiktokSyncPo: false })}
                        disabled={this.state._isForceTiktokSyncProgress}
                      />{" "}
                      Ready Stock
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="forceTiktokSyncPo"
                        checked={!!this.state._forceTiktokSyncPo}
                        onChange={() => this.setState({ _forceTiktokSyncPo: true })}
                        disabled={this.state._isForceTiktokSyncProgress}
                      />{" "}
                      Pre-Order (PO)
                    </Label>
                  </FormGroup>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  color="secondary"
                  onClick={this._closeForceTiktokSyncModal}
                  disabled={this.state._isForceTiktokSyncProgress}
                >
                  Cancel
                </Button>
                <ButtonLoading
                  type="button"
                  color="warning"
                  isLoading={this.state._isForceTiktokSyncProgress}
                  loadingMessage="Syncing..."
                  onClick={this._handleForceTiktokSync}
                >
                  Force Sync
                </ButtonLoading>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state._isForceShopeeSyncModalOpen}
              toggle={this._closeForceShopeeSyncModal}
              size="sm"
            >
              <ModalHeader toggle={this._closeForceShopeeSyncModal}>
                Force Shopee Sync
              </ModalHeader>
              <ModalBody>
                <p className="mb-3">
                  Sync Shopee stock and price for this variant
                  {this.state._form.SKU ? ` (${this.state._form.SKU})` : ""}.
                </p>
                <FormGroup tag="fieldset">
                  <Label>Stock type</Label>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="forceShopeeSyncPo"
                        checked={!this.state._forceShopeeSyncPo}
                        onChange={() => this.setState({ _forceShopeeSyncPo: false })}
                        disabled={this.state._isForceShopeeSyncProgress}
                      />{" "}
                      Ready Stock
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="radio"
                        name="forceShopeeSyncPo"
                        checked={!!this.state._forceShopeeSyncPo}
                        onChange={() => this.setState({ _forceShopeeSyncPo: true })}
                        disabled={this.state._isForceShopeeSyncProgress}
                      />{" "}
                      Pre-Order (PO)
                    </Label>
                  </FormGroup>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  color="secondary"
                  onClick={this._closeForceShopeeSyncModal}
                  disabled={this.state._isForceShopeeSyncProgress}
                >
                  Cancel
                </Button>
                <ButtonLoading
                  type="button"
                  color="warning"
                  isLoading={this.state._isForceShopeeSyncProgress}
                  loadingMessage="Syncing..."
                  onClick={this._handleForceShopeeSync}
                >
                  Force Sync
                </ButtonLoading>
              </ModalFooter>
            </Modal>
            <FormGroup>
              <Label for="formProductDetail">Details</Label>
              <RichTextEditor
                value={this.state._form.detailsValue}
                onChange={this.handleChangeEditor}
								blockStyleFn={getTextAlignClassName}
              />
              {/* <div>{this.state._form.details}</div> */}
            </FormGroup>
            <Row>
              <Col xs={12} md={12}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "price_source",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductPriceSource">Price Source</Label>
                  <Input
                    type="text"
                    id="formProductPriceSource"
                    name="price_source"
                    placeholder="Enter a price source"
                    value={textValue("price_source", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("price_source", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "retail_price",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductRetailPrice">Retail Price</Label>
                  <Input
                    type="text"
                    id="formProductRetailPrice"
                    name="retail_price"
                    placeholder="Enter a retail price"
                    value={textValue("retail_price", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("retail_price", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "currency",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductCurrency">Currency</Label>
                  <Input
                    type="text"
                    id="formProductCurrency"
                    name="currency"
                    placeholder="Enter a retail price's currency"
                    value={textValue("currency", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("currency", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "retail_price_indonesia",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductIndonesiaRetailPrice">Indonesia Retail Price</Label>
                  <Input
                    type="text"
                    id="formProductIndonesiaRetailPrice"
                    name="retail_price_indonesia"
                    placeholder="Enter a indonesia retail price"
                    value={textValue("retail_price_indonesia", this.state._form)}
                    onChange={this.handleChange}
                  />
                  {errorMessage("retail_price_indonesia", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "release_date",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductReleaseDate">Release Date</Label>
                  <InputDatetime
                    inputProps={{ placeholder: "Pick a Release Date" }}
                    value={dateValue("release_date", this.state._form)}
                    onChange={date =>
                      this.handleDatePickerChange(date, "release_date")
                    }
                    timeFormat="HH:mm"
                  />
                  {errorMessage("release_date", this.state._errorForm)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classNames({
                    "has-danger has-feedback": hasError(
                      "expiry_date",
                      this.state._errorForm
                    )
                  })}
                >
                  <Label for="formProductExpiryDate">Expiry Date</Label>
                  <InputDatetime
                    inputProps={{ placeholder: "Pick a Expiry Date" }}
                    value={dateValue("expiry_date", this.state._form)}
                    onChange={date =>
                      this.handleDatePickerChange(date, "expiry_date")
                    }
                    timeFormat="HH:mm"
                  />
                  {errorMessage("expiry_date", this.state._errorForm)}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label>Created At</Label>
                  <Input
                    type="text"
                    readOnly
                    value={textValue("created_at", this.state._form)}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label>Updated At</Label>
                  <Input
                    type="text"
                    readOnly
                    value={textValue("updated_at", this.state._form)}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Modal
              isOpen={this.state._isMarketplaceProductIdConfirmOpen}
              toggle={this._closeMarketplaceProductIdConfirmModal}
            >
              <ModalHeader toggle={this._closeMarketplaceProductIdConfirmModal}>
                Confirm marketplace product ID changes
              </ModalHeader>
              <ModalBody>
                <p className="mb-3">
                  These marketplace product IDs will be updated
                  {this.state._form.SKU ? ` for ${this.state._form.SKU}` : ""}.
                  This remaps existing TikTok / Shopee listings for this variant.
                </p>
                {this.state._marketplaceProductIdChanges.map(change => (
                  <div key={change.name} className="mb-3">
                    <strong>{change.label}</strong>
                    <div className="mt-1" style={{ wordBreak: "break-all" }}>
                      <div>
                        <span className="text-muted">From: </span>
                        {change.from || "(blank)"}
                      </div>
                      <div>
                        <span className="text-muted">To: </span>
                        {change.to || "(blank)"}
                      </div>
                    </div>
                  </div>
                ))}
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  color="secondary"
                  onClick={this._closeMarketplaceProductIdConfirmModal}
                  disabled={this.state._isSubmitProgress}
                >
                  Cancel
                </Button>
                <ButtonLoading
                  type="button"
                  color="warning"
                  isLoading={this.state._isSubmitProgress}
                  loadingMessage="Saving..."
                  onClick={this._confirmMarketplaceProductIdChanges}
                >
                  Confirm and Submit
                </ButtonLoading>
              </ModalFooter>
            </Modal>
            <FormGroup>
              <ButtonGroup>
                <ButtonLoading isLoading={this.state._isSubmitProgress}>
                  Submit
                </ButtonLoading>
                {/* {this.props.usingDelete ? (
                  <Button color="danger" onClick={this.onDelete}>
                    Delete
                  </Button>
                ) : (
                  ""
                )} */}
              </ButtonGroup>
            </FormGroup>
          </Form>
        </Col>
      </Loading>
    );
  }
}

ProductVariant.defaultProps = {
  subcategoryOptions: [],
  subcategoryOptionsLoading: false,
  onFetchSubcategoryOptions: () => {}
};

ProductVariant.propTypes = {
  usingDelete: propTypes.bool,
  isLoading: propTypes.bool,
  isSubmitProgress: propTypes.bool,
  subcategoryOptions: propTypes.array,
  subcategoryOptionsLoading: propTypes.bool,
  onFetchSubcategoryOptions: propTypes.func,
  products: propTypes.array,
  productVariant: propTypes.shape({
    id: propTypes.number,
    product_id: propTypes.number,
    display_name: propTypes.string,
    type: propTypes.string,
    dimension: propTypes.string,
    nickname: propTypes.string,
    ribbon_tag: propTypes.string,
    colour: propTypes.string,
    weight: propTypes.any,
    SKU: propTypes.string,
    sex: propTypes.string,
    active: propTypes.any,
    details: propTypes.string,
    price_source: propTypes.string,
    // editors_choice:propTypes.any,
    release_date: propTypes.string,
    expiry_date: propTypes.string,
    created_at: propTypes.string,
    updated_at: propTypes.string
  }),
  onDelete: propTypes.func,
  onSubmit: propTypes.func
};
